import { render, staticRenderFns } from "./NotificationShareCodes.vue?vue&type=template&id=1c0ccb26"
import script from "./NotificationShareCodes.vue?vue&type=script&lang=js"
export * from "./NotificationShareCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports